/**
 * 联系人管理服务 - 联系人相关 API
 */

import api from '../../api';
import type { Result, PageResult } from '../../types';
import type { Contact } from '../../../types';

export const getContacts = (params: Record<string, unknown>): Promise<Result<PageResult<Contact>>> => {
  // 与客户列表一致：避免 GET 层 5s 缓存导致联系人数量/负责人信息滞后
  return api.get('/crm/contacts', { params, enableCache: false } as Parameters<typeof api.get>[1]);
};

type ContactsPagePayload = { records?: Contact[]; total?: number };

/**
 * 分页拉齐全部联系人（后端 PageQuery 单页上限 100）
 */
export async function getAllContacts(): Promise<Contact[]> {
  const pageSize = 100;
  const maxPages = 200;
  const all: Contact[] = [];
  for (let pageNum = 1; pageNum <= maxPages; pageNum++) {
    const res = (await getContacts({ pageNum, pageSize })) as {
      code?: number;
      data?: ContactsPagePayload | Contact[];
    };
    if (res?.code !== 200 || res.data == null) {
      break;
    }
    const raw = res.data;
    const list = Array.isArray(raw) ? raw : raw.records ?? [];
    all.push(...list);
    if (list.length < pageSize) {
      break;
    }
    const total = Array.isArray(raw) ? undefined : raw.total;
    if (typeof total === 'number' && all.length >= total) {
      break;
    }
  }
  return all;
}

export const getContactById = (id: string): Promise<Result<Contact>> => {
  return api.get(`/crm/contacts/${id}`);
};

export const createContact = (data: Partial<Contact> | Record<string, unknown>): Promise<Result<Contact>> => {
  return api.post('/crm/contacts', data);
};

export const updateContact = (id: string, data: Partial<Contact> | Record<string, unknown>): Promise<Result<Contact>> => {
  return api.put(`/crm/contacts/${id}`, data);
};

export const deleteContact = (id: string): Promise<Result<void>> => {
  return api.delete(`/crm/contacts/${id}`);
};

export const getContactsByCompany = (companyId: string): Promise<Result<Contact[]>> => {
  return api.get(`/crm/contacts/by-company/${companyId}`);
};
